import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreRegister } from '../SatCoreRegistry';

import GoogleAnalyticsService from '../services/GoogleAnalyticsService';

const GoogleAnalyticsLauncher = observer((_props) => {
  const { googleAnalyticsManager } = useContext(MobXProviderContext);

  const { googleAnalyticsId } = googleAnalyticsManager;

  useEffect(() => {
    if (googleAnalyticsId) {
      GoogleAnalyticsService.initGoogleAnalyticsIfApplicable({ googleAnalyticsId });
    }
  }, [googleAnalyticsId]);

  return null;
});

export default GoogleAnalyticsLauncher;

SatCoreRegister('GoogleAnalyticsLauncher', GoogleAnalyticsLauncher);
